import styled from 'styled-components';
import { Fonts, Colors } from '@ace/ace-ui-web';

export const ErrorBoundaryWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const ErrorBoundaryContent = styled.div`
  width: 85%;
  margin: 0 auto;
  text-align: center;

  & > span {
    &:last-of-type {
      padding-top: 20px;
      font-size: 18px;
      font-style: italic;
    }
  }
`;

export const ErrorBoundaryText = styled.span`
  font-family: ${Fonts.ROBOTO_MEDIUM};
  color: ${Colors.aceGray};
  font-size: 22px;
  display: block;
`;

export const ErrorBoundaryButtonWrapper = styled.div`
  & button {
    margin-top: 25px;
    width: 100%;
  }
`;